import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/Contato.css";

import { database } from "../services/firebase";
import { ref, push, set } from "firebase/database";

// Ícones (React Icons)
import { MdEmail, MdPhone, MdLocationOn, MdAccessTime, MdSend, MdCheckCircle } from "react-icons/md";

const Contato = () => {
    // Estado do formulário
    const [form, setForm] = useState({
        nome: "",
        email: "",
        assunto: "",
        mensagem: "",
    });

    // Estados de feedback visual (Carregando / Sucesso)
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    // Atualiza os inputs conforme digita
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    // Função de envio (Simulação sem Backend)
    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            if (!form.nome || !form.email || !form.assunto || !form.mensagem) {
                setError(true);
                return;
            }

            setLoading(true);

            const messagesRef = ref(database, "messages/");
            const newMessage = push(messagesRef);
            const messageId = newMessage.key;

            await set(newMessage, {
                ...form,
                createdAt: Date.now(),
            });

            setLoading(false);
            setSuccess(true);
            setError(false);
            setForm({ nome: "", email: "", assunto: "", mensagem: "" });
            
            setTimeout(() => setSuccess(false), 4000);

        } catch (e) {
            console.error("Erro ao enviar mensagem:", e);
            setError(true);
            setLoading(false);
        }

    };

    return (
        <>
            <Header />

            <div className="contato-page">
                <div className="contato-container">

                    {/* CABEÇALHO DA SEÇÃO */}
                    <div className="contato-header">
                        <span className="subtitle">FALE CONOSCO</span>
                        <h1>Estamos aqui para ajudar</h1>
                        <p>
                            Tem alguma dúvida sobre nossos pratos ou sua reserva?
                            Preencha o formulário ou use um de nossos canais diretos.
                        </p>
                    </div>

                    {/* CONTEÚDO PRINCIPAL */}
                    <div className="contato-content">

                        {/* LADO ESQUERDO: INFO CARDS */}
                        <div className="info-box">
                            <div className="info-list">
                                <InfoItem
                                    icon={<MdEmail />}
                                    title="Email"
                                    text="contato@uaithai.com.br"
                                    subtext="Respondemos em até 24h"
                                />
                                <InfoItem
                                    icon={<MdPhone />}
                                    title="Telefone / WhatsApp"
                                    text="(32) 99172-0072"
                                    subtext="Seg a Sex, 9h às 18h"
                                />
                                <InfoItem
                                    icon={<MdLocationOn />}
                                    title="Restaurante"
                                    text="Beco do Rosário - Rua Operário Geraldo Rezende, 85"
                                    subtext="Centro, Tiradentes - MG"
                                />
                                <InfoItem
                                  icon={<MdAccessTime />}
                                  title="Horário"
                                  text={
                                    <>
                                      Ter a Dom: 13h - 15h30<br />
                                      Ter a Sáb: 19h - 22h30
                                    </>
                                  }
                                  subtext="Fechado às segundas"
                                />
                            </div>
                        </div>

                        {/* LADO DIREITO: FORMULÁRIO */}
                        <div className="form-box">
                            <h3>Envie uma mensagem</h3>

                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="input-group">
                                        <label>Seu Nome</label>
                                        <input
                                            type="text"
                                            name="nome"
                                            required
                                            value={form.nome}
                                            onChange={handleChange}
                                            placeholder="Digite seu nome"
                                        />
                                    </div>
                                    <div className="input-group">
                                        <label>Seu Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            required
                                            value={form.email}
                                            onChange={handleChange}
                                            placeholder="exemplo@email.com"
                                        />
                                    </div>
                                </div>

                                <div className="input-group">
                                    <label>Assunto</label>
                                    <input
                                        type="text"
                                        name="assunto"
                                        required
                                        value={form.assunto}
                                        onChange={handleChange}
                                        placeholder="Motivo do contato"
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Como podemos ajudar?</label>
                                    <textarea
                                        name="mensagem"
                                        required
                                        rows="5"
                                        value={form.mensagem}
                                        onChange={handleChange}
                                        placeholder="Digite sua mensagem aqui..."
                                    ></textarea>
                                </div>

                                <div className="form-actions">
                                    <button type="submit" className="btn-enviar" disabled={loading}>
                                        {loading ? "Enviando..." : (
                                            <>
                                                Enviar Mensagem <MdSend className="icon-send" />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* NOTIFICAÇÃO DE SUCESSO (TOAST) */}
            <div className={`toast-notification ${success ? "show" : ""}`}>
                <MdCheckCircle className="toast-icon" />
                <span>Mensagem enviada com sucesso!</span>
            </div>

            <div className={`toast-notification ${error ? "show" : ""}`}>
                <MdCheckCircle className="toast-icon" />
                <span>Preencha todos os campos para enviar.</span>
            </div>

            <Footer />
        </>
    );
};

// Sub-componente para os itens de informação
const InfoItem = ({ icon, title, text, subtext }) => (
    <div className="info-item">
        <div className="icon-circle">
            {icon}
        </div>
        <div className="info-text">
            <strong>{title}</strong>
            <span>{text}</span>
            {subtext && <small>{subtext}</small>}
        </div>
    </div>
);

export default Contato;